/**
 * Small shared controls used across sections (prototype classes, plan 8.2 / 8.3).
 */

import React from "react";
import { Link } from "react-router-dom";
import Icon from "./Icon";
import { ROUTES } from "../state/constants";

export const Switch = ({ on, onChange, disabled, label, id }) => (
  <button
    type="button"
    id={id}
    role="switch"
    aria-checked={on ? "true" : "false"}
    aria-label={label}
    className={`eb-ui-switch ${on ? "on" : ""}`.trim()}
    disabled={disabled}
    onClick={() => !disabled && onChange(!on)}
  >
    <span />
  </button>
);

export const FieldError = ({ message }) => (message ? <small className="eb-field-error">{message}</small> : null);

export const Helper = ({ children }) => <small className="eb-helper">{children}</small>;

/** `Upgrade` / `Teams plan` / `After trial` / `Coming soon` badge (8.2 locked UI). */
export const PlanBadge = ({ kind = "upgrade", to = ROUTES.SUBSCRIPTION }) => {
  const text = { upgrade: "Upgrade", teams: "Teams plan", afterTrial: "After trial", comingSoon: "Coming soon" }[kind] || "Upgrade";
  if (kind === "comingSoon") return <span className="eb-coming-badge">{text}</span>;
  return (
    <Link className="eb-plan-badge" to={to}>
      <Icon name="lock" size={11} /> {text}
    </Link>
  );
};

/** 3.4 rule 11 — data for a feature the plan no longer includes. */
export const DowngradeNote = ({ children }) => (
  <div className="eb-downgrade-note">
    <Icon name="info" size={14} />
    <span>{children || "Not in your plan \u2014 removed the next time this section is saved."}</span>
  </div>
);

/** One setting row: strong + p on the left, controls on the right. */
export const SettingLine = ({ title, text, children, compact, id, className = "" }) => (
  <div className={`eb-setting-line ${compact ? "compact" : ""} ${className}`.trim()} id={id}>
    <div>
      <strong>{title}</strong>
      {text ? <p>{text}</p> : null}
    </div>
    <div className="eb-line-right">{children}</div>
  </div>
);

export const SelectWrap = ({ icon = "calendar", children, className = "" }) => (
  <div className={`eb-select-wrap ${className}`.trim()}>
    <Icon name={icon} size={17} />
    {children}
    <Icon name="chevron-down" size={15} />
  </div>
);

export const SettingsGroup = ({ title, text, action, children, id, className = "" }) => (
  <div className={`eb-settings-group ${className}`.trim()} id={id}>
    <div className="eb-settings-card-title">
      <div>
        <h2>{title}</h2>
        {text ? <p>{text}</p> : null}
      </div>
      {action || null}
    </div>
    {children}
  </div>
);

export const numberOr = (value, fallback = 0) => {
  const n = parseInt(value, 10);
  return Number.isNaN(n) ? fallback : n;
};
